export default __webpack_public_path__ + "static/media/property-analytics-feature-blue.b611537a.png";